import jsCookie from 'js-cookie'

/**
 * 加个 undefined”是为了覆盖“未显式设置 domain 的主机级 cookie
 */
function getRootDomain(hostname) {
  if (!hostname || hostname === 'localhost' || /^\d+\.\d+\.\d+\.\d+$/.test(hostname)) return hostname
  const parts = hostname.split('.')
  if (parts.length <= 2) return hostname
  return parts.slice(-2).join('.')
}

function removeCookieEverywhere(name) {
  const hostname = typeof window !== 'undefined' ? window.location.hostname : undefined
  const root = hostname ? getRootDomain(hostname) : undefined
  const domains = []
  // if (hostname) domains.push(hostname)
  if (root && root !== hostname) domains.push('.' + root)
  console.log('domains', domains)
  const paths = ['/']
  domains.forEach((domain) => {
    paths.forEach((path) => {
      try {
        jsCookie.remove(name, { domain, path })
        console.log(name, domain, path)
      } catch (_) {
        // ignore
        console.log('err', _)
      }
    })
  })
}

function removeCookiesByPrefix(prefix) {
  if (typeof document === 'undefined') return
  const all = document.cookie ? document.cookie.split('; ') : []
  all.forEach((kv) => {
    const eqIdx = kv.indexOf('=')
    const key = eqIdx === -1 ? kv : kv.slice(0, eqIdx)
    if (key.startsWith(prefix)) removeCookieEverywhere(key)
  })
}

function clearGoogleCookie(policyData) {
  const denyAll = !Object.values(policyData).some((v) => v === 'granted')
  if (denyAll) {
    const prefixCookies = ['_ga', '_gat', '_gac_', '_gcl_', 'cto', '_pubcid', 'pbjs-', '_awl']
    const constCookies = ['_gid', '__gpi', '__gads']
    prefixCookies.forEach((prefix) => {
      removeCookiesByPrefix(prefix)
    })
    constCookies.forEach((cookie) => {
      removeCookieEverywhere(cookie)
    })
  }
}

typeof window !== 'undefined' &&
  cmpListen((data) => {
    clearGoogleCookie(data)
  })

/**
 * cmp内容，如果为空说明是非欧盟去语
 * @param {*} cb
 * 唯一key
 */
export function cmpListen(cb) {
  // Queue the callback using the CONSENT_API_READY key on the callbackQueue.
  window.googlefc.callbackQueue.push({
    CONSENT_API_READY: () =>
      __tcfapi('addEventListener', 2.2, (tcData, success) => {
        if (tcData.purpose && tcData.purpose.consents) {
          const consents = tcData.purpose.consents
          // 用户已经做了选择
          const adStorage = consents[1] && consents[2] ? 'granted' : 'denied'
          //  1：存储和/或访问设备上的信息（这是基础）， 7：测量内容效果（可能包括分析）
          const analyticsStorage = consents[1] && consents[7] ? 'granted' : 'denied'
          // 基础广告、用户画像、广告个性化
          const adPersonalization = consents[2] && consents[3] && consents[4] ? 'granted' : 'denied'

          const adUserData = consents[1] && consents[2] ? 'granted' : 'denied'
          const functionalityStorage = consents[1] ? 'granted' : 'denied'
          const policyData = {
            adStorage,
            analyticsStorage,
            adPersonalization,
            adUserData,
            functionalityStorage
          }
          clearGoogleCookie(policyData)
          cb(policyData, tcData)
        } else {
          // 用户没有触发选择，判断 GDPR适用性， true gdpr适用于当前用户（欧盟用户）， false 则不适用（非欧盟用户）
          if (tcData.gdprApplies) {
            // 弹窗正在显示，不做处理
          } else {
            cb(
              {
                adStorage: 'granted',
                analyticsStorage: 'granted',
                adPersonalization: 'granted',
                adUserData: 'granted',
                functionalityStorage: 'granted'
              },
              tcData
            )
          }
        }
      })
  })
}
